module.exports = __webpack_public_path__ + "img/tencentCloud.a14a08fc.png";